// extracted by mini-css-extract-plugin
export default {"table":"DifficultyDistributionModelInfo_table__kZRjZ"};